import { useEffect } from "react";
import { useAuth } from "../lib/auth";

/**
 * iter-116: light-mode applier — now PER-USER.
 * iter-178: also toggles `html.mode-compact` from
 * `preferences.compact_mode` so every dialog / sheet in the app can
 * respond via `.mode-compact` CSS rules in `index.css`.
 */
export default function ThemeApplier() {
    const { user } = useAuth();
    // iter-131e: Light mode is temporarily LOCKED for everyone.
    const THEME_LOCKED = true;
    const light = THEME_LOCKED
        ? true
        : user?.preferences?.theme_light_mode !== false;

    // iter-178: Compact mode. Off by default; opt-in from Account.
    const compact = Boolean(user?.preferences?.compact_mode);

    useEffect(() => {
        const html = document.documentElement;
        if (light) html.classList.add("theme-light");
        else html.classList.remove("theme-light");
    }, [light]);

    useEffect(() => {
        const html = document.documentElement;
        if (compact) html.classList.add("mode-compact");
        else html.classList.remove("mode-compact");
    }, [compact]);

    return null;
}
